module.exports = __webpack_public_path__ + "static/media/planets.c469b26d.png";